import {createSelector} from '@reduxjs/toolkit'

const privacyNoticeSelector = createSelector(
    [state => state.components],
    ({privacyNotice}) => {
        return privacyNotice
    }
)

export const privacyNoticeSelect = state => ({
    privacyNotice: privacyNoticeSelector(state)
})
